<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M8.985,15.78c-0.044,0-0.088-0.004-0.13-0.011c-0.513-0.061-0.922-0.47-0.983-0.983c-0.008-0.043-0.012-0.087-0.012-0.131
		s0.004-0.088,0.011-0.131c0.06-0.513,0.47-0.922,0.983-0.982c0.042-0.008,0.086-0.011,0.13-0.011s0.088,0.004,0.13,0.011
		c0.513,0.06,0.922,0.469,0.983,0.982c0.008,0.043,0.012,0.087,0.012,0.131s-0.004,0.088-0.011,0.131
		c-0.06,0.513-0.47,0.922-0.983,0.982C9.073,15.776,9.03,15.78,8.985,15.78z"/>
	<path d="M14.985,15.78c-0.044,0-0.088-0.004-0.13-0.011c-0.513-0.06-0.923-0.47-0.983-0.983c-0.007-0.042-0.011-0.086-0.011-0.131
		s0.004-0.088,0.011-0.131c0.06-0.513,0.47-0.923,0.983-0.983c0.042-0.008,0.086-0.011,0.131-0.011s0.088,0.004,0.131,0.011
		c0.513,0.06,0.923,0.47,0.983,0.983c0.008,0.042,0.011,0.086,0.011,0.131s-0.004,0.088-0.011,0.131
		c-0.06,0.513-0.47,0.923-0.983,0.983C15.073,15.776,15.029,15.78,14.985,15.78z"/>
	<path d="M7.336,24.016C5.898,24.013,4.722,22.932,4.6,21.5l-0.79-9.462H3.5c-0.414,0-0.75-0.336-0.75-0.75s0.336-0.75,0.75-0.75
		h4.088C6.541,9.732,5.73,8.647,5.252,7.39C4.568,5.591,4.626,3.634,5.415,1.878c0.109-0.242,0.297-0.446,0.529-0.573
		c0.182-0.1,0.386-0.152,0.592-0.152c0.45,0,0.864,0.244,1.08,0.638l1.338,2.432c0.606-1.255,1.265-2.464,1.963-3.605
		c0.223-0.369,0.633-0.599,1.069-0.599c0.227,0,0.45,0.062,0.645,0.18c0.173,0.105,0.32,0.251,0.424,0.424
		c0.695,1.142,1.352,2.352,1.958,3.604l1.34-2.436c0.217-0.394,0.631-0.638,1.081-0.638c0.207,0,0.413,0.053,0.594,0.153
		c0.23,0.127,0.417,0.33,0.526,0.569c1.391,3.098,0.427,6.667-2.171,8.663h4.087c0.414,0,0.75,0.336,0.75,0.75
		s-0.336,0.75-0.75,0.75h-0.309c0,0-0.789,9.469-0.789,9.473c-0.127,1.427-1.301,2.503-2.735,2.505
		C16.637,24.016,7.336,24.016,7.336,24.016z M6.094,21.374c0.055,0.65,0.59,1.141,1.243,1.142h9.298
		c0.653-0.001,1.187-0.492,1.243-1.143l0.777-9.335H5.315L6.094,21.374z M13.345,10.371c0.333-0.082,0.659-0.194,0.975-0.337
		c2.697-1.212,3.995-4.274,3.071-7.02L13.345,10.371z M6.578,3.015C6.156,4.263,6.18,5.609,6.654,6.857
		C7.196,8.281,8.259,9.41,9.65,10.034c0.316,0.142,0.642,0.254,0.975,0.336L6.578,3.015z M11.985,9.732l2.136-3.884
		c-0.64-1.41-1.357-2.785-2.137-4.096C11.2,3.062,10.483,4.437,9.847,5.846L11.985,9.732z"/>
	<path d="M8.862,21.022c-0.109,0-0.214-0.023-0.314-0.069c-0.376-0.174-0.54-0.62-0.367-0.995c0.417-0.904,1.144-1.631,2.048-2.048
		c0.554-0.256,1.143-0.385,1.749-0.385c1.632,0,3.127,0.955,3.809,2.433c0.173,0.376,0.008,0.822-0.366,0.995
		c-0.1,0.046-0.206,0.069-0.314,0.069c-0.291,0-0.559-0.171-0.681-0.435c-0.438-0.949-1.398-1.563-2.446-1.563
		c-0.389,0-0.767,0.083-1.122,0.248c-0.58,0.268-1.047,0.734-1.315,1.314C9.421,20.851,9.154,21.022,8.862,21.022z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'plant-sad',
    },
    name: {
      type: String,
      required: false,
      default: 'PlantSad',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>